var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8998 5.20152L20.0383 9.34009C20.3056 10.0076 20.9739 10.4081 21.6421 10.5416L26.1863 11.2091C27.9238 11.4761 28.5921 13.6122 27.3892 14.8137L24.0479 17.8842C23.5133 18.4183 23.246 19.0858 23.3796 19.7533L24.1815 24.1589C24.4489 25.8944 22.7114 27.2294 21.1075 26.4284L16.9643 24.2924C16.296 24.0254 15.6277 24.0254 14.9595 24.2924L10.8162 26.4284C9.21237 27.2294 7.47487 25.8944 7.74218 24.1589L8.5441 19.7533C8.67775 19.0858 8.41045 18.2847 7.87583 17.8842L4.66815 14.6802C3.33162 13.4787 4.13354 11.3426 5.87103 11.0756L10.4152 10.4081C11.0835 10.2746 11.7518 9.8741 12.0191 9.34009L14.0239 5.20152C14.9595 3.59949 17.0979 3.59949 17.8998 5.20152Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.cb69750ebb1e147a7dbc1b0cca7ca98a.svg";
export { ForwardRef as ReactComponent };